import { useMemo }      from 'react';
import { connect }      from 'react-redux';
import { reducerType }  from 'reducer';
import { userInfoType } from 'types';
import { makeStyles }   from 'makeStyles';
import getSemelFromUserInfo from 'utils/getSemelFromUserInfo';

const useStyles = makeStyles()(() => ({
    root: {
       display:        'flex',
       height:         '100%',
       justifyContent: 'center',
       textAlign:      'left',
       flexFlow:       'column'
    },
    item: {
        margin:   5,
        fontSize: 17
    },
    label: {
        fontWeight: 600,
        marginRight: 6
    }
}));

type UserDataType = {
    userInfo: userInfoType;
}

const hiddenKeys = new Set(['gradeAccess']);

const formatValue = (value: any): string => {
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  if (value === undefined || value === null || value === '') {
    return '—';
  }
  return String(value);
};

const labelMap: Record<string, string> = {
  semelMosad: 'semelMosad (סמל מוסד)',
};

const UserData: React.FC<UserDataType> = ({ userInfo }) => {

  const { classes } = useStyles();
  const semelDisplay = useMemo(() => getSemelFromUserInfo(userInfo), [userInfo]);

  const infoEntries = useMemo(() => {
     const entries = Object.entries(userInfo).filter(([key]) => !hiddenKeys.has(key));
     return entries.map(([key, value]) => {
        if (key === 'semelMosad') {
          return [key, semelDisplay || value] as [string, any];
        }
        return [key, value] as [string, any];
     });
  },[userInfo, semelDisplay]);

  return (
    <div className = { classes.root }>
       {
           infoEntries.map(([key, value]) => (
               <div
                 key       = { `${ key }?!?!?` }
                 className = { classes.item }
                 dir       = 'ltr'
               >
                   <span className={classes.label}>{ (labelMap[key] ?? key) }:</span>
                   <span>{ formatValue(value) }</span>
               </div>
           ))
       }
    </div>   
  );
}

const mapStateToProps = (reducer: reducerType) => {
    return {
       userInfo: reducer.data.userInfo,
  }};
  
export default connect(mapStateToProps)(UserData);
